import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Rabbits from "./pages/Rabbits";
import RabbitDetail from "./pages/RabbitDetail";
import CareGuide from "./pages/CareGuide";
import Guarantee from "./pages/Guarantee";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Reserve from "./pages/Reserve";
import ReserveSuccess from "./pages/ReserveSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const RequireAdmin = ({ children }) => {
  const { admin, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-stone">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Site><Home /></Site>} />
            <Route path="/rabbits" element={<Site><Rabbits /></Site>} />
            <Route path="/rabbits/:id" element={<Site><RabbitDetail /></Site>} />
            <Route path="/care-guide" element={<Site><CareGuide /></Site>} />
            <Route path="/guarantee" element={<Site><Guarantee /></Site>} />
            <Route path="/about" element={<Site><About /></Site>} />
            <Route path="/contact" element={<Site><Contact /></Site>} />
            <Route path="/reserve/:rabbitId" element={<Site><Reserve /></Site>} />
            <Route path="/reserve/success" element={<Site><ReserveSuccess /></Site>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
